import React from "react";
import PropTypes from "prop-types";
import { Backdrop, CircularProgress } from "@mui/material";

// Covers the entire screen (including sidenav/navbar) and blocks all clicks
// underneath while `open` is true.
const FullScreenLoader = ({ open }) => (
  <Backdrop
    open={open}
    sx={{
      color: "#fff",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: (theme) => theme.zIndex.modal + 1000,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <CircularProgress color="inherit" size={60} />
  </Backdrop>
);

FullScreenLoader.propTypes = {
  open: PropTypes.bool,
};

FullScreenLoader.defaultProps = {
  open: false,
};

export default FullScreenLoader;
